goog.provide("shadow.js.shim.module$src$svg$shapes$circle$circle_small_fill_svg$default");
shadow.js.shim.module$src$svg$shapes$circle$circle_small_fill_svg$default = shadow.js.shim.module$src$svg$shapes$circle$circle_small_fill_svg.default;
